/** Ranking horizontal (top endpoints, top sistemas). Continua sendo série única: a cor não
 *  identifica nada — quem identifica é o rótulo à esquerda; por isso todas as barras usam a
 *  mesma cor e o valor vai direto ao lado, sem legenda e sem tooltip. */
export default function BarrasRanking({ itens = [], rotuloVazio = 'Sem dados no período.', onClickItem }) {
  if (!itens.length) {
    return (
      <div className="empty-state" style={{ padding: 26 }}>
        <i className="bi bi-list-ol" />
        <div>{rotuloVazio}</div>
      </div>
    );
  }

  const maximo = Math.max(...itens.map((i) => i.total), 1);

  return (
    <div className="d-flex flex-column gap-2">
      {itens.map((item) => (
        <div key={item.chave} className="d-flex align-items-center gap-2">
          <div
            style={{
              width: 150,
              flexShrink: 0,
              fontSize: 12.5,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              cursor: onClickItem ? 'pointer' : 'default',
              color: onClickItem ? 'var(--wh-accent-dk)' : 'var(--wh-ink)',
            }}
            title={item.rotulo}
            onClick={onClickItem ? () => onClickItem(item) : undefined}
          >
            {item.rotulo}
          </div>
          <div className="barra-inline__trilho">
            <div className="barra-inline" style={{ width: `${(item.total / maximo) * 100}%` }} />
          </div>
          <div style={{ width: 52, textAlign: 'right', fontSize: 12.5, fontWeight: 700 }}>{item.total}</div>
        </div>
      ))}
    </div>
  );
}
